import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { IToast, IToastParam, IToastProvider } from "./types";

const ToastContext = createContext<IToastProvider>({} as IToastProvider);

export function ToastProvider({ children }: { children: JSX.Element }) {
  const [toasts, setToasts] = useState<IToast[]>([]);

  const handleClose = (id: string) =>
    setToasts((currentToasts) =>
      currentToasts.filter(({ id: currentToastId }) => currentToastId === id)
    );

  const handleOpen = useCallback(
    (toast: IToastParam) => {
      const toastId = String(Date.now());
      setToasts([
        ...toasts,
        { ...toast, id: toastId, onClose: () => handleClose(toastId) },
      ]);
    },
    [toasts]
  );

  const contextValue = useMemo(
    () => ({ toasts, handleOpen }),
    [handleOpen, toasts]
  );

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within an ToastProvider");
  }
  return context;
}
